// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  MaintenanceStatus,
  Source,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  title: __t.string(),
  components: __t.array(__t.string()),
  startsAt: __t.timestamp().name("starts_at"),
  endsAt: __t.timestamp().name("ends_at"),
  get status() {
    return MaintenanceStatus;
  },
  message: __t.string(),
  get source() {
    return Source;
  },
  runId: __t.string().name("run_id"),
});
